import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_BASE_URL from '../../config/api';

export const fetchLeaderboard = createAsyncThunk(
    'leaderboard/fetch',
    async (timeframe, { rejectWithValue, getState }) => {
        try {
            const { auth: { token } } = getState();
            if (!token) {
                return rejectWithValue('No authentication token, authorization denied');
            }
            const response = await axios.get(`${API_BASE_URL}/leaderboard/${timeframe}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch leaderboard');
        }
    }
);
